export const CourseSegmentOptions = [
  { label: 'Academy', value: 'Academy' },
  { label: 'Competence Hub', value: 'Competence Hub' },
  { label: 'RIS', value: 'RIS' },
  { label: 'Other', value: 'Other' },
];

export const DefaultCourseSegment = 'Other';
